module.exports = __webpack_public_path__ + "assets/media/level-05.02b7abc0.png";